var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 140c38.66 0 70-31.34 70-70s-31.34-70-70-70S.5 31.34.5 70s31.34 70 70 70Z",
    fill: "#DEDEFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Error_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 141,
    height: 140
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 140c38.66 0 70-31.34 70-70s-31.34-70-70-70S.5 31.34.5 70s31.34 70 70 70Z",
    fill: "#DEDEFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5 140h-84V49.466a14.95 14.95 0 0 0 14.933-14.933h54.134a14.833 14.833 0 0 0 4.378 10.554 14.826 14.826 0 0 0 10.555 4.38V140Z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.502 95.2c12.37 0 22.4-10.029 22.4-22.4 0-12.371-10.03-22.4-22.4-22.4-12.372 0-22.4 10.029-22.4 22.4 0 12.371 10.028 22.4 22.4 22.4Z",
    fill: "#5D5BEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m78.42 83.36-7.92-7.92-7.92 7.92-2.64-2.64 7.92-7.92-7.92-7.92 2.64-2.64 7.92 7.92 7.92-7.92 2.64 2.64-7.92 7.92 7.92 7.92-2.64 2.64Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.633 100.801H58.366a2.8 2.8 0 1 0 0 5.6h24.267a2.8 2.8 0 0 0 0-5.6ZM91.035 112H49.968a2.8 2.8 0 0 0 0 5.6h41.067a2.8 2.8 0 0 0 0-5.6Z",
    fill: "#9E9DF2"
  })));
};
export default SvgError;